var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGlifosato = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 11.5532L16 15.9998H7.99995L11.3333 11.5532V7.99984H12.6666V11.5532ZM14.64 6.6665H9.35995C9.07995 6.6665 8.92662 6.9865 9.09995 7.2065L9.99995 8.33317V11.1132L6.13329 16.2665C5.80662 16.7065 6.11995 17.3332 6.66662 17.3332H17.3333C17.88 17.3332 18.1933 16.7065 17.8666 16.2665L14 11.1132V8.33317L14.9 7.2065C15.0733 6.9865 14.92 6.6665 14.64 6.6665Z",
    fill: "#696F88"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGlifosato);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Glifosato.4ca08b7090dad03cbce9e0b813d66d1a.svg";